import organise from './organise';
import eng from '../data/eng.json';

export default function (country) {
    const map = {
        eng,
    };  
    return organise(map[country] || map.eng);
}